import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";
import {V1ChangeOrderMemberIDOCToArray} from "../../../../util/Payload";

// The records inside a change order (t1/v1/change_order_members).
//
// NO UPDATE PATH, deliberately. A member is a link plus a snapshot of what the record was when it
// joined, and there is nothing on it to edit that would not be a lie about history. Changing which
// record is in a change order is removing one and adding another -- which is also what keeps the
// content hash honest about what people signed for, since membership is registered as a CHILD of the
// change order and is therefore inside that hash.
const URL = "t1/v1/change_order_members";
const IDOC = "v1.ChangeOrderMember-001";

class ChangeOrderMemberEnterpriseComponent extends EnterpriseComponent {

    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        const idocResponse = this.getIDOCResponse() ?? IDOC;

        const members = [];
        const queryPayload = this.prepareQueryPayload();
        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;
                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) operator = queryPayload.get(key + "_query");
                members.push({"Type": "Attribute", "Name": key, "Value": value, "Operator": operator});
            }
        }

        const QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "ChangeOrderMember": {
                    "_attributes": {"limit": pageSize, "sort": this.getFormattedSortSpecification(), "offset": (page - 1) * pageSize},
                    "QueryGroups": {"QueryGroup": [{"Name": "primary", "Operator": "AND", "Type": "QueryGroup", "Membership": {"Member": members}}]}
                }
            }
        };

        AxiosFoundationAPI({
            method: "GET",
            url: URL,
            json: true,
            params: {"QBE": btoa(JSON.stringify(QBE))},
            headers: {
                "visibility-mode": this.getVisibilityMode(),
                "visibility-value": this.getVisibilityValue(),
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ChangeOrderMemberIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    buildPayload = () => {
        const r = {};
        r["USID"] = this.getAttributeValue("USID");
        // FALLS BACK TO THE SCOPE, because a member added from a change order's grid belongs to that
        // change order and nothing in the dialog asks for it. newRecord() applies defaults and the
        // realm but NOT the scope, so without this the parent arrives empty.
        r["ChangeOrderUSID"] = this.getAttributeValue("ChangeOrderUSID")
            || (this.getScope && this.getScope().get ? this.getScope().get("ChangeOrderUSID") : null);
        r["RecordUSID"] = this.getAttributeValue("RecordUSID");
        r["Reason"] = this.getAttributeValue("Reason");
        // Every other column is a SNAPSHOT the server stamps from the record itself. A
        // client-supplied name would be a claim about what was reviewed.
        return r;
    };

    enterpriseComponentPostIDOC = () => {
        const payload = {};
        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = IDOC;
        payload.PlatformMessage.ChangeOrderMember = this.buildPayload();
        return payload;
    };

    performInsert() {
        const options = {method: "POST", url: URL, json: true, data: this.enterpriseComponentPostIDOC(),
                         headers: {"idoc-request": IDOC, "idoc-response": IDOC}};
        this.notifyInsertStartListeners();
        AxiosFoundationAPI(options)
            .then(response => { this.insertEnterpriseComponentSuccess(V1ChangeOrderMemberIDOCToArray(response.data)); })
            .catch(error => { this.insertEnterpriseComponentFailed(error); });
    };

    performDelete() {
        const payload = {};
        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = IDOC;
        payload.PlatformMessage.ChangeOrderMember = {"USID": this.getAttributeValue("USID")};
        const options = {method: "DELETE", url: URL, json: true, data: payload,
                         headers: {"idoc-request": IDOC, "idoc-response": IDOC}};
        this.notifyDeleteStartListeners();
        AxiosFoundationAPI(options)
            .then(() => { this.deleteEnterpriseComponentSuccess(); })
            .catch(error => { this.deleteEnterpriseComponentFailed(error); });
    };
}

export default ChangeOrderMemberEnterpriseComponent;
